import React, { useState, useEffect } from 'react';
// REDUX
import { useDispatch, useSelector } from 'react-redux';
//
import { FormattedMessage } from 'react-intl';
// ANTD
import { Menu, Dropdown } from 'antd';
// ACTION

// CSS
import './LanguageSwitcher.css';

import dk from 'static/img/countries/dk.png';
import de from 'static/img/countries/de.png';
import gb from 'static/img/countries/gb.png';
import no from 'static/img/countries/no.png';
import du from 'static/img/countries/nl.png';
import fi from 'static/img/countries/fi.png';
import se from 'static/img/countries/se.png';
// import ru from 'static/img/countries/ru.png';
import { userHistory } from '../../../constants/user.constants';
import guestIdentService from '../../Utility/guestIdent.service';
import userAPI from '../../../API/user.service.api';
import { languageActiveChange } from '../../../actions/Language/language.action';

const images = {
  dk,
  de,
  gb,
  no,
  du,
  fi,
  se,
  // ru,
};

const guestIdent = guestIdentService();

const menu = (handleClick) => {
  return (
    <Menu
      onClick={({ key }) => handleClick(key)}
      items={[
        {
          label: (
            <>
              <img src={images.dk} alt="Dansk" />
              <span>Dansk</span>
            </>
          ),
          key: 'da',
        },
        {
          label: (
            <>
              <img src={images.de} alt="Deutsch" />
              <span>Deutsch</span>
            </>
          ),
          key: 'de',
        },
        {
          label: (
            <>
              <img src={images.gb} alt="English" />
              <span>English</span>
            </>
          ),
          key: 'en',
        },
        {
          label: (
            <>
              <img src={images.no} alt="Norsk" />
              <span>Norsk</span>
            </>
          ),
          key: 'no',
        },
        {
          label: (
            <>
              <img src={images.du} alt="Dutch" />
              <span>Dutch</span>
            </>
          ),
          key: 'du',
        },
        {
          label: (
            <>
              <img src={images.fi} alt="Finnish" />
              <span>Finnish</span>
            </>
          ),
          key: 'fi',
        },
        {
          label: (
            <>
              <img src={images.se} alt="Swedish" />
              <span>Swedish</span>
            </>
          ),
          key: 'se',
        },
        // {
        //   label: (
        //     <>
        //       <img src={images.ru} alt="Русский" />
        //       <span>Русский</span>
        //     </>
        //   ),
        //   key: 'ru',
        // },
      ]}
    />
  );
};

let postpone = null;
let isSet = null;
const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const active = useSelector((store) => store.languageData.active);
  const { isLoggedIn, user } = useSelector((store) => store.authentication);

  const [lang, setLang] = useState({});

  const handleClick = (key) => {
    switch (key) {
      case 'da':
        dispatch(languageActiveChange('da'));
        setLang({ code: 'da', imgCode: 'dk' });
        break;
      case 'de':
        dispatch(languageActiveChange('de'));
        setLang({ code: 'de', imgCode: 'de' });
        break;
      // case 'ru':
      //   dispatch(languageActiveChange('ru'));
      //   setLang({ code: 'ru', imgCode: 'ru' });
      //   break;
      case 'no':
        dispatch(languageActiveChange('no'));
        setLang({ code: 'no', imgCode: 'no' });
        break;
      case 'du':
        dispatch(languageActiveChange('du'));
        setLang({ code: 'du', imgCode: 'du' });
        break;
      case 'fi':
        dispatch(languageActiveChange('fi'));
        setLang({ code: 'fi', imgCode: 'fi' });
        break;
      case 'se':
        dispatch(languageActiveChange('se'));
        setLang({ code: 'se', imgCode: 'se' });
        break;
      default:
        dispatch(languageActiveChange('en'));
        setLang({ code: 'en', imgCode: 'gb' });
        break;
    }
  };

  useEffect(() => {
    userAPI.getUserLocation().then((res) => {
      const { code, country } = res;
      if (code === 200) {
        if (country === 'DK') {
          handleClick('da');
          isSet = true;
        }
      }
      if (!isSet) {
        handleClick(active);
      }
    });
  }, []);

  useEffect(() => {
    const userId = isLoggedIn && user ? user.id : guestIdent.get();
    userAPI
      .getHistoryFeUserData(userId, userHistory.USER_LANGUAGE)
      .then((res) => {
        const { entities } = res;
        if (postpone) clearTimeout(postpone);
        if (entities && entities !== active && !isSet) {
          postpone = setTimeout(() => {
            handleClick(entities || active);
          }, 3000);
        }
      })
      .catch((err) => console.log(err));
  }, [isLoggedIn]);

  return (
    <Dropdown
      overlay={menu(handleClick)}
      overlayClassName="languageSwitcherDropDown"
      trigger={['click']}
      placement="bottom"
    >
      {lang ? (
        <span className="languageSwitcher">
          <img
            src={images[lang.imgCode]}
            style={{ width: 20, marginTop: 6 }}
            alt="contry flag"
          />
          <span>
            <FormattedMessage id="Language" defaultMessage="Language" />
          </span>
        </span>
      ) : (
        <span />
      )}
    </Dropdown>
  );
};

export default LanguageSwitcher;
